const State = {
  refundList: []
}

export default State
